import Label from "components/Label/Label";
import React, { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import UserService from "app/services/userService";
import { toast } from "react-hot-toast";
import Notify from "components/Notify";
import { Notification } from "app/helpers/sendnotification";
import Dash from "containers/dash";

const AccountPass = () => {
  const [password, setPassword] = useState<string>("")
  const [newPassword, setNewPassword] = useState<string>("")
  const [confirmPassword, setConfirmPassword] = useState<string>("")
  const updateHandler = () => {
    let message = "Votre mot de passe a été mis à jour"
    let status = "success"
    let error = false
    if(newPassword.length < 8){
      message = "Votre mot de passe est très court"
      status = "error"
      error = true
    }
    if(newPassword != confirmPassword){
      message = "Mot de passe de confirmation incorrect"
      status = "error"
      error = true
    }
    const data = {
      password: password,
      new_password: newPassword,
      confirm_password: confirmPassword
    }
    if(!error){
      UserService.updateFormPassword(data).then(response =>{
        if (response.data == 'ok')
        Notification(status, message)
      
      }).catch(erroe => {
        let message = erroe.response.data.detail
        if(message == 'incorrect current password')
          message = 'Mot de passe actuel incorrect'
        Notification( 'error', message)
      })
    }else{
      Notification(status, message)
    }
 
  }
  return (
   
      <Dash>
        <div className="space-y-10 sm:space-y-12 p-10">
          {/* HEADING */}
          <h2 className="text-2xl sm:text-3xl font-semibold">
            Mettez à jour votre mot de passe
          </h2>
          <div className=" max-w-xl space-y-6">
            <div>
              <Label>Mot de passe actuel</Label>
              <Input type="password" className="mt-1.5" onChange={e => setPassword(e.target.value)} />
            </div>
            <div>
              <Label>Nouveau mot de passe</Label>
              <Input type="password" className="mt-1.5"  onChange={e => setNewPassword(e.target.value)}/>
            </div>
            <div>
              <Label>Confirmez le mot de passe</Label>
              <Input type="password" className="mt-1.5"  onChange={e => setConfirmPassword(e.target.value)} />
            </div>
            <div className="pt-2">
              <ButtonPrimary onClick={updateHandler}>Mettre à jour le mot de passe</ButtonPrimary>
            </div>
          </div>
        </div>
      </Dash>

  );
};

export default AccountPass;
